<template>
    <div>
        <crud-delete :open="open"
            :loading="loading || loadingImpact"
            :title="title"
            :errorMessage="errorMessage"
            @delete="onDeleteClick"
            @close="$emit('close')"
        >
            <v-card-text>
                <tamanio-show-data :item="item" />
            </v-card-text>

            <v-card-text>
                <v-row justify="center">
                    <span class="title">{{ areYouSure }}</span>
                </v-row>
            </v-card-text>
        </crud-delete>

        <confirm-dialog v-model="showConfirmImpact"
            :title="$t('tamanio.modals.deleteImpact.title')"
            :description="impactDescription"
            confirm-color="error"
            max-width="400px"
            @confirmed="executeDelete"
        />
    </div>
</template>

<script>
    import TamanioProvider from "../../../providers/TamanioProvider";
    import TamanioShowData from "../TamanioShow/TamanioShowData";
    import { CrudDelete, ConfirmDialog } from '@dracul/common-frontend';
    import ClientError from "@/errors/ClientError";

    export default {
        name: "TamanioDelete",

        components: { TamanioShowData, CrudDelete, ConfirmDialog },

        props: {
            open: { type: Boolean, default: true },
            item: { type: Object, required: true }
        },

        data() {
            return {
                modal: false,
                title: 'tamanio.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
                loadingImpact: false,
                showConfirmImpact: false,
                pendingImpact: null,
            }
        },

        computed: {
            impactDescription() {
                if (!this.pendingImpact) return ''
                const { productosCount, depositosCount } = this.pendingImpact
                const desc = this.$t('tamanio.modals.deleteImpact.description', {
                    productosCount,
                    depositosCount
                })
                const question = this.$t('tamanio.modals.deleteImpact.confirmQuestion')
                return `${desc} ${question}`
            }
        },

        methods: {
            onDeleteClick() {
                this.loadingImpact = true
                this.errorMessage = ''
                TamanioProvider.getTamanioUpdateImpact(this.item.id)
                    .then(r => {
                        if (r?.data?.tamanioUpdateImpact) {
                            this.pendingImpact = r.data.tamanioUpdateImpact
                            this.showConfirmImpact = true
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                    })
                    .finally(() => { this.loadingImpact = false })
            },
            executeDelete() {
                this.loading = true
                this.errorMessage = ''
                TamanioProvider.deleteTamanio(this.item.id)
                    .then(result => {
                        if (result.data.tamanioDelete.success) {
                            this.$emit('itemDeleted', result.data.tamanioDelete)
                            this.$emit('close')
                        } else {
                            this.errorMessage = 'Error on Delete'
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                    })
                    .finally(() => {
                        this.loading = false
                        this.pendingImpact = null
                    })
            },
        },
    }
</script>


